import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory';
import { getCsrfToken } from '../utils/csrf'
import { prefixUrlWithLocale } from '../utils/url'
import { RetryLink } from "apollo-link-retry";
import { ApolloLink } from 'apollo-link/lib/link';

export type Edge<K> = {
  node: K
  cursor: string
}


export type Connection<K> = {
  nodes: K[]
  edges: Edge<K>[]
  pageInfo: {
    endCursor: string
    hasNextPage: boolean
    hasPreviousPage: boolean
    startCursor: string
  }
}

const getRetryLink = () => new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true
  },
  attempts: {
    max: 5,
    retryIf: (error, _operation) => !!error
  }
})

const getAuthLink = () => setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'X-CSRF-Token': getCsrfToken(),
    }
  }
})

const getHttpLink = () => createHttpLink({
  uri: prefixUrlWithLocale('/graphql'), credentials: 'same-origin'
})

export const getClient = () : ApolloClient<NormalizedCacheObject> => {
  const link = ApolloLink.from([
    getRetryLink(),
    getAuthLink(),
    getHttpLink()
  ]);

  return new ApolloClient({
    link: link,
    cache: new InMemoryCache(),
  });
}

